import { render, staticRenderFns } from "./SlotMachine.vue?vue&type=template&id=23bc792a&"
import script from "./SlotMachine.vue?vue&type=script&lang=js&"
export * from "./SlotMachine.vue?vue&type=script&lang=js&"
import style0 from "./SlotMachine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports